// Port of api/fuel/app/classes/controller/api/monty/config/save.php
import DB from 'offline/db'

export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id') || false
	var data = params.data || {}

	if (!userId) {
		return Promise.reject({ error: 'Not available offline without a local session.', offline: true })
	}

	var existing = DB.query('SELECT config_id FROM config WHERE user_id = ?', [userId])
	var payload = JSON.stringify(data)

	if (existing.length) {
		DB.run('UPDATE config SET config_data = ? WHERE user_id = ?', [payload, userId])
	} else {
		DB.run('INSERT INTO config (user_id, config_data) VALUES (?, ?)', [userId, payload])
	}

	return DB.save().then(function() {
		return {
			session: { offline: true },
			data: {
				config: data
			}
		}
	})
}
